import { ROLE_TYPE } from './../../config/global';
import { useAuthStoreWithOut } from './auth';
import { useCommonStoreWithOut } from '@/store/modules/common'
import { defineStore } from 'pinia'
import { asyncRouterMap, constantRouterMap } from '@/router'
import { generateRoutesFn1, generateRoutesFn2, flatMultiLevelRoutes } from '@/utils/routerHelper'
import { store } from '../index'
import { cloneDeep } from 'lodash-es'
const authStore = useAuthStoreWithOut()
const commonStore = useCommonStoreWithOut()

export interface PermissionState {
  routers: AppRouteRecordRaw[]
  addRouters: AppRouteRecordRaw[]
  authRouters: AppRouteRecordRaw[],
  isAddRouters: boolean
  menuTabRouters: AppRouteRecordRaw[]
}

export const usePermissionStore = defineStore({
  id: 'permission',
  state: (): PermissionState => ({
    routers: [],
    addRouters: [],
    authRouters: [],
    isAddRouters: false,
    menuTabRouters: []
  }),
  persist: {
    enabled: true
  },
  getters: {
    getRouters(): AppRouteRecordRaw[] {
      return this.routers
    },
    getAddRouters(): AppRouteRecordRaw[] {
      return flatMultiLevelRoutes(cloneDeep(this.addRouters))
    },
    getIsAddRouters(): boolean {
      return this.isAddRouters
    },
    getMenuTabRouters(): AppRouteRecordRaw[] {
      return this.menuTabRouters
    },
    getAuthRouters(): AppRouteRecordRaw[] {
      return this.authRouters
    }
  },
  actions: {
    generateRoutes(
      type: 'admin' | 'test' | 'none',
      routers?: AppCustomRouteRecordRaw[] | string[]
    ): Promise<unknown> {
      return new Promise<void>((resolve) => {
        let routerMap: AppRouteRecordRaw[] = []

        routerMap = cloneDeep(asyncRouterMap)
        this.authRouters = cloneDeep(routerMap)
        // 动态路由，404一定要放到最后面
        this.addRouters = routerMap.concat([
          {
            path: '/:path(.*)*',
            redirect: '/404',
            name: '404Page',
            meta: {
              hidden: true,
              breadcrumb: false
            }
          }
        ])
        // 渲染菜单的所有路由
        this.routers = cloneDeep(constantRouterMap).concat(routerMap)
        resolve()
      })
    },
    setIsAddRouters(state: boolean): void {
      this.isAddRouters = state
    },
    setMenuTabRouters(routers: AppRouteRecordRaw[]): void {
      this.menuTabRouters = routers
    }
  }
})

function filterRoutes(sourceRoutes:AppRouteRecordRaw[], authRoutes:any[]) {
  // 先将用户可访问的routes列表转换成map形式，提高查找效率
  const authRoutesMap = {}
  authRoutes.forEach(parent => {
    const children = {}
    parent.children?.forEach(child => {
      children[child.id] = child
    })
    parent.children = children
    authRoutesMap[parent.id] = parent
  })
  console.log("authRoutesMap:", authRoutesMap)

  // 过滤
  const res = <any>[]
  for (const parent of sourceRoutes) {
    const authParent = authRoutesMap[parent.name]
    if (!authParent) {
      continue
    }
    const parentCopy = cloneDeep(parent)
    parentCopy.children = []
    if (parent.children) {
      for (const child of parent.children) {
        const childCopy = cloneDeep(child)
        const authChild = authRoutesMap[parent.name].children[child.name]
        // 必须配置有并且read设置为true
        if (authChild && authChild.read) {
          parentCopy.children.push(childCopy)
        }
        
        // 不暴漏在菜单上的路由需要做特殊处理
        // template/batch, template/partsin, parts/partsin, parts/partsdetail
        if (child.name === 'Template') {
          // 要访问basic/template/batch和basic/template/partsin必须拥有template的写权限
          if (!authChild || !authChild.write) childCopy.children = []
        }
        // 要访问partsin必须拥有partslist的写权限
        if (child.name === 'PartsIn') {
          if (authRoutesMap['PartsManage']
              && authRoutesMap['PartsManage'].children
              && authRoutesMap['PartsManage'].children['PartsList'] 
              && authRoutesMap['PartsManage'].children['PartsList'].write) parentCopy.children.push(childCopy)
        }
        // 要访问partsdetail必须拥有partslist的访问权限
        if (child.name === 'PartsDetail') {
          if (authRoutesMap['PartsManage']
              && authRoutesMap['PartsManage'].children
              && authRoutesMap['PartsManage'].children['PartsList']) parentCopy.children.push(childCopy)
        }
      }
    }
    // 如果一个child都没有则不显示
    if (parentCopy.children.length > 0) res.push(parentCopy)
  }

  return res
}

export const usePermissionStoreWithOut = () => {
  return usePermissionStore(store)
}
